import React from 'react'
import { motion } from 'framer-motion'

const AdminLoading: React.FC = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
    <div className="flex flex-col items-center">
      <motion.div
        className="border-t-blue mb-8 size-24 rounded-full border-4"
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
      />
      <motion.h2 className="text-blue text-2xl font-semibold" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        Loading Admin Panel
      </motion.h2>
      <motion.div className="mt-4 h-2 w-48 overflow-hidden rounded-full bg-gray-200">
        <motion.div className="bg-blue h-full" initial={{ width: 0 }} animate={{ width: '100%' }} transition={{ duration: 2, repeat: Infinity }} />
      </motion.div>
    </div>
  </div>
)

export default AdminLoading
